import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  Icon,
  Form,
  Input,
  Header,
  Popup,
  Radio,
  Divider,
} from 'semantic-ui-react';
import cn from 'classnames';

import { colors } from 'utils/colors';
import { isGlobeInvestor, convertToTickersAndWeights } from 'utils/helpers';
import { Accounts, CacheInputs, Planning, Portfolio } from 'actions';
import {
  AccountsDropdown,
  Message,
  Segment,
  ErrorLabel,
  Button,
  PortfolioAccountSelector,
} from 'components';
import Result from './Result';
import EducationCard from '../components/EducationCardSaving';
import RetirementCard from '../components/RetirementCardSaving';
import { translation as translationPlanning } from '../../Translation/planning';
import { translation as translationCommon } from '../../Translation/common';

class TargetSaving extends Component {
  componentWillMount() {
    const { dispatch, targetSavingInputs } = this.props;
    const { inf } = targetSavingInputs;

    dispatch(Portfolio.fetchModel());
    dispatch(Portfolio.fetchUser());
    dispatch(Accounts.fetchAll());
    dispatch(Accounts.fetchAllData());
    if (!inf) {
      dispatch(
        CacheInputs.updateField('planning', 'target_saving', {
          inf: 2,
          errors: { inf: null },
        })
      );
    }

    return false;
  }

  getNewPortDate = (initialDate) => {
    const date = new Date(initialDate);
    const today = new Date();
    const monthDifference =
      today.getMonth() -
      date.getMonth() +
      12 * (today.getFullYear() - date.getFullYear());
    if (monthDifference > 120) {
      return false;
    }

    const init = date.toDateString().toString().split(/\s+/);

    const months = {
      Jan: 'January',
      Feb: 'February',
      Mar: 'March',
      Apr: 'April',
      May: 'May',
      Jun: 'June',
      Jul: 'July',
      Aug: 'August',
      Sept: 'September',
      Oct: 'October',
      Nov: 'November',
      Dec: 'December',
    };

    return `${months[init[1]]} ${init[3]}`;
  };

  getParamsPort = () => {
    const { portfolios, targetSavingInputs } = this.props;
    const { portID } = targetSavingInputs;
    const portfolio = portfolios.find((item) => item.id === portID);

    return {
      symbols: portfolio.symbols,
      weights: portfolio.weights,
      region: portfolio.region,
      gic_info: portfolio.gic_info,
      init_date: portfolio.init_date,
    };
  };

  getParamsAcc = () => {
    const { accountList, accountData, targetSavingInputs, user_region } =
      this.props;
    const { portID } = targetSavingInputs;
    if (!accountData) {
      return {};
    }
    const account = accountList.find((item) => item.id === portID);
    const accountInfo = accountData.find((item) => item.id === portID);
    const accToPort = convertToTickersAndWeights(account.holdings);
    const gicFormat = /^GIC\d*:MKT$/;
    const gicList = account.holdings.filter((holding) => {
      if (
        gicFormat.test(holding.security) ||
        gicFormat.test(holding.security_detail.ticker)
      ) {
        return true;
      }

      return false;
    });

    const gic_info = gicList.reduce((acc, gicKey) => {
      acc[gicKey.ticker] = {
        gic_name: gicKey.gic_name,
        gic_quantity: gicKey.quantity,
        gic_rate: gicKey.gic_rate,
        gic_ticker: gicKey.gic_ticker,
      };

      return acc;
    }, {});

    return {
      symbols: accToPort.tickers,
      weights: accToPort.weights,
      region: user_region,
      gic_info,
      init_date: accountInfo.analytics_start_date,
    };
  };

  handleSubmit = () => {
    const { dispatch, targetSavingInputs, accountData, french } = this.props;
    const { targ, inf, init, horz, portID, isPorts } = targetSavingInputs;
    const language = french ? 'fr' : 'en';

    if (this.hasEmptyValue(Object.keys({ targ, init, inf, horz, portID }))) {
      return false;
    }

    if (!isPorts) {
      if (!accountData) return false;
      const account = accountData.find((item) => item.id === portID);
      if (account.analytics_start_date === null) {
        dispatch(
          CacheInputs.updateField('planning', 'target_saving', {
            errors: {
              portID: translationPlanning[language].TARGET_SAVING.ANALYZE_ERROR,
            },
          })
        );

        return false;
      }
    }

    const selectionParams = isPorts
      ? this.getParamsPort()
      : this.getParamsAcc();
    const params = {
      ...selectionParams,
      targ,
      inf: inf === 0 ? 0 : parseFloat(inf) / 100 || 0.02,
      init,
      horz,
      is_targ_nominal: false,
    };

    return dispatch(Planning.analyzeSaving(params)).then(() =>
      this.scrollHandler(
        document.documentElement,
        document.getElementById('ref').offsetHeight,
        600
      )
    );
  };

  handlePortfolioChange = (e, { value }) => {
    const { dispatch, targetSavingInputs } = this.props;
    const { errors } = targetSavingInputs;

    dispatch(Planning.clearSectionData('savingResult'));

    return dispatch(
      CacheInputs.updateField('planning', 'target_saving', {
        portID: value,
        errors: { ...errors, portID: null },
      })
    );
  };

  handleHeaderChange = (value) => {
    const { dispatch, targetSavingInputs } = this.props;
    const { errors } = targetSavingInputs;
    dispatch(Planning.clearSectionData('savingResult'));

    return dispatch(
      CacheInputs.updateField('planning', 'target_saving', {
        isPorts: value,
        portID: '',
        errors: { ...errors, portID: null },
      })
    );
  };

  isCalculateDisabled = () => {
    const { targetSavingInputs } = this.props;
    const { initFromAcc, initAccList } = targetSavingInputs;

    if (initAccList && initAccList.length === 0 && initFromAcc) return true;
    return false;
  };

  hasEmptyValue = (values) =>
    values.some((field) => {
      const { dispatch, targetSavingInputs, french } = this.props;
      const { isPorts } = targetSavingInputs;
      const language = french ? 'fr' : 'en';

      if (!targetSavingInputs[field] && targetSavingInputs[field] !== 0) {
        return dispatch(
          CacheInputs.updateField('planning', 'target_saving', {
            errors: {
              [field]:
                field === 'portID'
                  ? isPorts
                    ? translationPlanning[language].TARGET_SAVING
                        .REQUIRED_PORTFOLIO
                    : translationPlanning[language].TARGET_SAVING
                        .REQUIRED_ACCOUNT
                  : translationPlanning[language].TARGET_SAVING.REQUIRED_FIELD,
            },
          })
        );
      }

      return false;
    });

  scrollHandler = (element, to, duration) => {
    if (duration <= 0) return false;
    const difference = to - element.scrollTop;
    const perTick = (difference / duration) * 10;

    return setTimeout(() => {
      element.scrollTop += perTick;
      // for safari compatibility
      if (element.scrollTop === 0) {
        document.body.scrollTop += perTick;
      }
      if ((element.scrollTop || document.body.scrollTop) >= to) return false;
      return this.scrollHandler(element, to, duration - 10);
    }, 10);
  };

  handleChange = (e, { name, value }) => {
    const { dispatch, targetSavingInputs } = this.props;
    const { errors } = targetSavingInputs;
    const num = Number(value);
    const limitRegex =
      name === 'inf' ? /^[0-9]{1,9}(\.[0-9]{0,2})?$/ : /^[0-9]{1,9}$/;
    if (value !== '' && !limitRegex.test(value)) return;
    if (name === 'horz' && value === '0') return;
    if (name === 'inf' && num < -100) {
      dispatch(
        CacheInputs.updateField('planning', 'target_saving', {
          [name]: 0,
          errors: { ...errors, inf: null },
        })
      );
    } else if (name === 'inf' && num > 100) {
      dispatch(
        CacheInputs.updateField('planning', 'target_saving', {
          [name]: 100,
          errors: { ...errors, inf: null },
        })
      );
    } else if (name === 'horz' && num > 100) {
      dispatch(
        CacheInputs.updateField('planning', 'target_saving', {
          [name]: 100,
          errors: { ...errors, horz: null },
        })
      );
    } else {
      dispatch(
        CacheInputs.updateField('planning', 'target_saving', {
          [name]: value ? (name === 'inf' ? value : Number(value)) : undefined,
          errors: { ...errors, [name]: null },
        })
      );
    }
  };

  render() {
    const {
      accountList,
      portfolios,
      isFetching,
      targetSavingInputs,
      dispatch,
      partnerName,
      accountData,
      french,
    } = this.props;
    const {
      targ,
      inf,
      init,
      initFromAcc,
      initAccList,
      horz,
      portID,
      errors,
      isPorts,
    } = targetSavingInputs;
    const portDate =
      portID &&
      (isPorts
        ? this.getNewPortDate(
            portfolios.find((port) => Number(port.id) === portID).init_date
          )
        : accountData
        ? this.getNewPortDate(
            accountData.find((port) => Number(port.id) === portID)
              .analytics_start_date
          )
        : false);

    let textValue = '';

    if (portID && portID !== 0) {
      if (isPorts) {
        if (portfolios && portfolios.length > 0) {
          const match = portfolios.find((p) => Number(p.id) === Number(portID));
          if (match) {
            textValue = match.name || '';
          }
        }
      } else if (accountList && accountList.length > 0) {
        const match = accountList.find((p) => Number(p.id) === Number(portID));
        if (match) {
          textValue = match.label || '';
        }
      }
    }

    const language = french ? 'fr' : 'en';
    const isQuoteMedia =
      partnerName === 'quotemedia_sandbox' ||
      partnerName === 'quotemedia_retail' ||
      partnerName === 'quotemedia_pro';

    return (
      <div style={{ overflowX: 'hidden' }}>
        <Segment textAlign="center">
          <div id="ref">
            <Header
              textAlign="center"
              size="large"
              content={translationPlanning[language].TARGET_SAVING.TITLE}
              subheader={translationPlanning[language].TARGET_SAVING.SUBTITLE}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                paddingTop: '1rem',
              }}
            >
              <EducationCard />
              <RetirementCard />
            </div>

            <StyledForm
              style={{
                width: '85%',
                maxWidth: '963px',
                margin: '2rem auto 0 auto',
                textAlign: 'left',
              }}
            >
              <Header
                size="medium"
                content={translationPlanning[language].INPUTS}
                style={{ margin: '2.5rem 0 1rem 0' }}
              />

              <Form.Group widths="equal">
                <Form.Field style={{ position: 'relative' }}>
                  <label>
                    {translationPlanning[language].TARGET_SAVING.TARGET_AMOUNT}
                  </label>
                  <Input
                    name="targ"
                    value={targ === 0 ? '0' : targ || ''}
                    icon="dollar"
                    iconPosition="left"
                    onChange={this.handleChange}
                  />
                  <ErrorLabel msg={errors.targ} />
                </Form.Field>
                <Form.Field style={{ position: 'relative' }}>
                  <label>
                    {translationPlanning[language].TARGET_SAVING.INFLATION_RATE}
                    <Popup
                      trigger={
                        <Icon
                          name="question circle outline"
                          style={{
                            fontSize: '15px',
                            verticalAlign: 'initial',
                            color: 'dimgrey',
                          }}
                        />
                      }
                      position="top center"
                      wide
                    >
                      {
                        translationPlanning[language].TARGET_SAVING
                          .INFLATION_RATE_POPUP
                      }
                    </Popup>
                  </label>
                  <Input
                    name="inf"
                    value={inf === 0 ? '0' : inf || ''}
                    icon="percent"
                    iconPosition="right"
                    defaultValue="2"
                    onChange={this.handleChange}
                  />
                  <ErrorLabel msg={errors.inf} />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field style={{ position: 'relative' }}>
                  <label>
                    {translationPlanning[language].TARGET_SAVING.CURRENT_AMOUNT}
                  </label>
                  {initFromAcc ? (
                    <AccountsDropdown
                      inputs={{}}
                      accountList={accountList}
                      selectedAccList={initAccList || []}
                      excludedList={[]}
                      savedAccountsValue={init || 0}
                      assignAccountsValue={(
                        selectedAccounts,
                        accountsValue
                      ) => {
                        this.props.dispatch(
                          CacheInputs.updateField('planning', 'target_saving', {
                            init: accountsValue,
                            initAccList: selectedAccounts,
                            errors: {
                              ...errors,
                              init: accountsValue ? null : errors.init,
                            },
                          })
                        );
                      }}
                      float={false}
                      error={errors.init}
                      zIndex={0}
                      isQuoteMedia={isQuoteMedia}
                    />
                  ) : (
                    <div>
                      <Input
                        name="init"
                        value={init === 0 ? '0' : init || ''}
                        icon="dollar"
                        iconPosition="left"
                        onChange={this.handleChange}
                      />
                      <ErrorLabel msg={errors.init} />
                    </div>
                  )}
                  {!isGlobeInvestor(partnerName) ? (
                    <Form
                      style={{ display: 'inline-block', marginTop: '0.5rem' }}
                    >
                      <Form.Field
                        style={{ display: 'inline-block', margin: '0 1rem' }}
                      >
                        <Radio
                          name="initFromAcc"
                          checked={!initFromAcc}
                          onChange={() =>
                            dispatch(
                              CacheInputs.updateField(
                                'planning',
                                'target_saving',
                                {
                                  init: 0,
                                  initFromAcc: false,
                                  initAccList: [],
                                }
                              )
                            )
                          }
                          label={
                            translationPlanning[language].TARGET_SAVING
                              .INPUT_VALUE
                          }
                        />
                      </Form.Field>
                      <Form.Field style={{ display: 'inline-block' }}>
                        <Radio
                          name="initFromAcc"
                          checked={initFromAcc}
                          onChange={() =>
                            dispatch(
                              CacheInputs.updateField(
                                'planning',
                                'target_saving',
                                {
                                  init: 0,
                                  initFromAcc: true,
                                  initAccList: [],
                                }
                              )
                            )
                          }
                          label={
                            isQuoteMedia
                              ? translationPlanning[language].TARGET_SAVING
                                  .SELECT_VALUE_PORTFOLIOS
                              : translationPlanning[language].TARGET_SAVING
                                  .SELECT_VALUE_ACCOUNTS
                          }
                        />
                      </Form.Field>
                    </Form>
                  ) : null}
                </Form.Field>
                <Form.Field style={{ position: 'relative' }}>
                  <label>
                    {translationPlanning[language].TARGET_SAVING.YEARS_TO_DATE}
                  </label>
                  <Input
                    name="horz"
                    value={horz === 0 ? '0' : horz || ''}
                    label={{ basic: true, content: 'years' }}
                    labelPosition="right"
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                  />
                  <ErrorLabel msg={errors.horz} style={{ bottom: '28px' }} />
                </Form.Field>
              </Form.Group>
            </StyledForm>
            <Divider
              style={{
                margin: '2rem auto 0',
                width: '85%',
                maxWidth: '963px',
              }}
            />
            <Header
              size="medium"
              textAlign="left"
              style={{
                width: '85%',
                maxWidth: '963px',
                margin: '1.5rem auto 0 auto',
              }}
            >
              {partnerName === 'quotemedia_pro' ||
              partnerName === 'quotemedia_sandbox' ||
              partnerName === 'quotemedia_retail'
                ? 'Select Simulation'
                : translationPlanning[language].TARGET_SAVING.SELECT_PORTFOLIO}
              <Header.Subheader style={{ margin: '0 auto 1rem auto' }}>
                {isGlobeInvestor(partnerName)
                  ? 'There are five simple index model portfolios in the dropdown list below. They hold a combination of Canadian universe bond and equity (50% Canadian and 50% U.S.) ETFs.'
                  : translationPlanning[language].TARGET_SAVING
                      .SELECT_PORTFOLIO_SUBTITLE}
              </Header.Subheader>
            </Header>

            <div
              style={{
                position: 'relative',
                width: '85%',
                maxWidth: '963px',
                margin: '0 auto',
              }}
            >
              <PortfolioAccountSelector
                value={`${portID}`}
                text={textValue}
                onChange={this.handlePortfolioChange}
                isPorts={isPorts}
                updateIsPorts={this.handleHeaderChange}
              />
            </div>
            <Message
              visible={!!errors.portID}
              error
              style={{
                margin: '1rem auto 0 auto',
                maxWidth: '45rem',
                textAlign: 'center',
              }}
            >
              <Message.Content>{errors.portID}</Message.Content>
            </Message>

            <Message
              icon
              visible={!!portDate}
              warning
              style={{
                margin: '1rem auto 0 auto',
                maxWidth: '45rem',
                textAlign: 'left',
              }}
            >
              <Icon name="exclamation" />
              {isPorts ? (
                <Message.Content>
                  {
                    translationPlanning[language].TARGET_SAVING
                      .SHORT_HISTORY_PORTFOLIO_1
                  }{' '}
                  <strong>{portDate}</strong>{' '}
                  {
                    translationPlanning[language].TARGET_SAVING
                      .SHORT_HISTORY_PORTFOLIO_2
                  }
                </Message.Content>
              ) : (
                <Message.Content>
                  {
                    translationPlanning[language].TARGET_SAVING
                      .SHORT_HISTORY_ACCOUNT_1
                  }{' '}
                  <strong>{portDate}</strong>{' '}
                  {
                    translationPlanning[language].TARGET_SAVING
                      .SHORT_HISTORY_ACCOUNT_2
                  }{' '}
                </Message.Content>
              )}
            </Message>

            <Button
              className={cn('centered right', {
                loading: isFetching,
                disabled: this.isCalculateDisabled(),
              })}
              color={colors.teal}
              icon="calculator"
              onClick={this.handleSubmit}
            >
              {translationCommon[language].CALCULATE}
            </Button>
          </div>
          <Result inf={inf} />
        </Segment>
      </div>
    );
  }
}

TargetSaving.propTypes = {
  dispatch: PropTypes.func.isRequired,
  portfolios: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  targetSavingInputs: PropTypes.object,
  accountList: PropTypes.array,
  user_region: PropTypes.string,
  partnerName: PropTypes.string,
  accountData: PropTypes.array,
  french: PropTypes.bool,
};

TargetSaving.defaultProps = {
  portfolios: [],
  targetSavingInputs: {},
  accountList: [],
  user_region: 'CA',
  partnerName: '',
  accountData: [],
  french: false,
};

export default connect((state) => ({
  isFetching: state.Planning.isFetching,
  portfolios: state.Portfolio.model.concat(state.Portfolio.user),
  targetSavingInputs: state.CacheInputs.planning.target_saving,
  accountList: state.Accounts.accountList,
  user_region: state.Storage.user_region,
  partnerName: state.Storage['partner-name'],
  accountData: state.Accounts.accountData,
  french: state.Storage.language === 'fr',
}))(TargetSaving);

const StyledForm = styled(Form)`
  &&& .field > label {
    font-size: 16px;
  }
`;
